<template>
  <!-- 모델 우측 고정 채팅 피드 (dev 전용). 각 소스(chzzk/twitch/chzzk_relay/debug) 이벤트를 시간순으로 -->
  <div class="feed-panel d-flex flex-column">
    <div class="feed-panel__head d-flex align-center">
      <v-icon size="16" color="#b388ff" class="mr-1">mdi-message-text</v-icon>
      <span class="feed-panel__title">채팅 피드</span>
      <v-spacer></v-spacer>
      <span class="feed-panel__count">{{ items.length }}</span>
      <v-btn icon x-small class="ml-1" @click="$emit('clear')"><v-icon size="16">mdi-trash-can-outline</v-icon></v-btn>
    </div>

    <div ref="scroll" class="feed-panel__body flex-grow-1">
      <div v-if="!items.length" class="feed-panel__empty">아직 수신된 이벤트가 없습니다.</div>
      <div v-for="it in items" :key="it.id" class="feed-row">
        <span class="feed-row__src" :style="{ background: srcColor(it.provider) }">{{ srcLabel(it.provider) }}</span>
        <span class="feed-row__body">
          <span v-if="it.type === 'DONATION'" class="feed-row__type don">💰 {{ formatAmount(it.amount) }}</span>
          <span v-else-if="it.type === 'SUBSCRIPTION'" class="feed-row__type sub">⭐ 구독</span>
          <span class="feed-row__nick">{{ it.nickname || "익명" }}</span>
          <span v-if="it.message" class="feed-row__msg" v-html="highlight(it.message, it.matchedKeywords)"></span>
        </span>
      </div>
    </div>

    <!-- 주입 입력 (dev): exp / 채팅 / 도네이션 테스트 이벤트 -->
    <div class="feed-panel__inject">
      <div class="inject-exp">
        <span class="inject-exp__label">EXP</span>
        <v-btn x-small depressed color="#3a3550" dark @click="_onExp(1)">1</v-btn>
        <v-btn x-small depressed color="#3a3550" dark @click="_onExp(10)">10</v-btn>
        <v-btn x-small depressed color="#3a3550" dark @click="_onExp(100)">100</v-btn>
        <v-btn x-small depressed color="#3a3550" dark @click="_onExp(1000)">1000</v-btn>
        <v-btn x-small depressed color="#3a3550" dark @click="_onExp(1000000000000)">max</v-btn>
      </div>
      <div class="inject-row">
        <v-text-field
          v-model="inputChat"
          dark
          dense
          outlined
          hide-details
          placeholder="채팅 주입"
          class="inject-row__field"
          @keydown.enter="_onChat"
        ></v-text-field>
        <v-btn small depressed color="#7C4DFF" dark @click="_onChat">Chat</v-btn>
      </div>
      <div class="inject-row">
        <v-text-field
          v-model="inputPayAmount"
          dark
          dense
          outlined
          hide-details
          type="number"
          placeholder="금액"
          class="inject-row__field"
          @keydown.enter="_onDonation"
        ></v-text-field>
        <v-btn small depressed color="#ffb020" @click="_onDonation">Donation</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
// provider → 짧은 라벨/색 (상태바 아이콘 색과 통일)
const SRC = {
  chzzk: { label: "치지직", color: "#16c79a" },
  chzzk_relay: { label: "릴레이", color: "#7C4DFF" },
  twitch: { label: "트위치", color: "#9146FF" },
  virtupet: { label: "제어", color: "#E91E63" },
  debug: { label: "디버그", color: "#9E9E9E" },
  unknown: { label: "기타", color: "#607D8B" },
};

export default {
  name: "ChatFeedPanel",
  props: {
    // [{ id, provider, type, nickname, message, amount }]
    items: { type: Array, default: () => [] },
  },
  data() {
    return {
      inputChat: "펫하",
      inputPayAmount: 10000,
    };
  },
  watch: {
    "items.length"() {
      this.$nextTick(this.scrollToBottom);
    },
  },
  methods: {
    _onExp(value) {
      this.$emit("exp", value);
    },
    _onChat() {
      const message = (this.inputChat || "").trim();
      if (!message) return;
      this.$emit("chat", { message, hidden: false });
      // 입력 유지(연속 채팅 테스트 편의 — 도네이션 금액 유지와 동일)
    },
    _onDonation() {
      this.$emit("donation", {
        profile: { nickname: "만수르사마" },
        extras: { payAmount: Number(this.inputPayAmount) || 0 },
      });
      // 금액은 유지(연속 도네 테스트 편의)
    },
    srcLabel(p) {
      return (SRC[p] || SRC.unknown).label;
    },
    srcColor(p) {
      return (SRC[p] || SRC.unknown).color;
    },
    formatAmount(a) {
      return a ? Number(a).toLocaleString() : "";
    },
    // 메시지를 HTML 이스케이프한 뒤, 매칭된 키워드 부분만 빨강(배경+글자)으로 감싼다.
    //  short-form .mark-1 스타일 재현(bg rgb(96,23,23) + color rgb(255,100,100)). v-html이라 반드시 이스케이프 선행.
    highlight(message, keywords) {
      const esc = (s) =>
        String(s == null ? "" : s)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");
      const text = esc(message);
      const ks = (keywords || []).filter(Boolean);
      if (!ks.length) return text;
      // 긴 키워드 우선(부분 겹침 방지) + HTML·정규식 이스케이프
      const parts = ks
        .slice()
        .sort((a, b) => b.length - a.length)
        .map((k) => esc(k).replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
      try {
        const re = new RegExp(parts.join("|"), "gi");
        return text.replace(re, (m) => `<span class="kw-hit">${m}</span>`);
      } catch (e) {
        return text;
      }
    },
    scrollToBottom() {
      const el = this.$refs.scroll;
      if (el) el.scrollTop = el.scrollHeight;
    },
  },
};
</script>

<style scoped>
.feed-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 320px;
  height: 100vh;
  background: rgba(20, 18, 28, 0.92);
  color: #e9e3ff;
  z-index: 20;
  border-left: 1px solid rgba(179, 136, 255, 0.25);
  font-size: 12px;
}
.feed-panel__head {
  padding: 8px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  flex: 0 0 auto;
}
.feed-panel__title {
  font-weight: 700;
  letter-spacing: 0.02em;
}
.feed-panel__count {
  color: #9e8fd0;
  font-variant-numeric: tabular-nums;
}
.feed-panel__body {
  overflow-y: auto;
  padding: 6px 8px;
}
.feed-panel__empty {
  color: #6f6a85;
  text-align: center;
  padding: 24px 0;
}
/* 키워드룰 매칭 하이라이트 — short-form .mark-1 재현(빨강 배경 + 빨강 글자) */
.feed-row__msg >>> .kw-hit {
  background-color: rgb(96, 23, 23);
  color: rgb(255, 100, 100);
  border-radius: 2px;
  padding: 0 2px;
}
.feed-row {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 3px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  line-height: 1.35;
}
.feed-row__src {
  flex: 0 0 auto;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  padding: 1px 5px;
  border-radius: 4px;
  white-space: nowrap;
}
.feed-row__body {
  min-width: 0;
  word-break: break-word;
}
.feed-row__type {
  font-weight: 700;
  margin-right: 4px;
}
.feed-row__type.don {
  color: #ffca6b;
}
.feed-row__type.sub {
  color: #7cf;
}
.feed-row__nick {
  font-weight: 700;
  color: #c9bdf5;
  margin-right: 4px;
}
.feed-row__msg {
  color: #e9e3ff;
}
.feed-panel__inject {
  flex: 0 0 auto;
  padding: 8px 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.inject-exp {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}
.inject-exp__label {
  font-size: 10px;
  font-weight: 700;
  color: #9e8fd0;
  margin-right: 2px;
}
.inject-row {
  display: flex;
  align-items: center;
  gap: 6px;
}
.inject-row__field {
  flex: 1 1 auto;
}
/* v-text-field 컴팩트하게 */
.feed-panel__inject >>> .v-input__slot {
  min-height: 32px !important;
}
.feed-panel__inject >>> input {
  font-size: 12px;
}
</style>
